// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"a07c5612","394":"a31d1bd4","478":"a31d1bd4","536":"a31d1bd4","686":"a6d1824b","695":"a07c5612","820":"a6d1824b","872":"a6d1824b"}[chunkId] + ".chunk.css";
};